import PropTypes from 'prop-types';

const DropdownLayover = ({ children }) => children;

DropdownLayover.propTypes = {
  children: PropTypes.node.isRequired,
};

DropdownLayover.displayName = 'DropdownLayover';

export default DropdownLayover;
